var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconeProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.65513C1 8.29775 1.19072 7.96753 1.50028 7.78894L12.5003 1.44279C12.8095 1.26437 13.1905 1.26437 13.4997 1.44279L24.4997 7.78894C24.8093 7.96753 25 8.29775 25 8.65513V21.3449C25 21.7023 24.8093 22.0325 24.4997 22.2111L13.4997 28.5572C13.1905 28.7356 12.8095 28.7356 12.5003 28.5572L1.50028 22.2111C1.19072 22.0325 1 21.7023 1 21.3449V8.65513Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.2924 19.6479C4.43049 19.5495 4.57756 19.4644 4.73166 19.3937L8.4306 17.697C8.83587 17.5349 9.16008 17.7781 9.4843 18.0212L12.7264 20.5339L15.9686 18.0212C16.2928 17.7781 16.6981 17.5349 17.0223 17.697L20.7591 19.3908C20.9194 19.4635 21.0727 19.5505 21.2172 19.6509C21.9465 20.1574 22.4042 20.9697 22.4597 21.8559L22.5 22.5C17.0694 30.6692 9.64641 30.6692 3.16211 22.5V21.8405C3.16211 20.9698 3.58321 20.1529 4.2924 19.6479Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.539 10.4031V12.6718C16.539 14.7785 14.8368 16.48 12.7294 16.48C10.622 16.48 8.91992 14.7785 8.91992 12.6718V10.4031C8.91992 5.86564 16.539 5.86564 16.539 10.4031Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeProfile);
export default __webpack_public_path__ + "static/media/iconeProfile.734eb970906d8e0b5fa472df81c93afe.svg";
export { ForwardRef as ReactComponent };